// extracted by mini-css-extract-plugin
export default {"thankYouMessage":"ZO2tWd","errorMessage":"tM_Cwr","errorIcon":"Fugsow"};